import React, { useState } from 'react';
import { translate } from '../../Services/translation';
import { post } from '../../Services/http';
import LoadingSpinner from '../Loading/LoadingSpinner';
import Icon from '../IconBase/Icon';
import(`./styles/${global.ThemeName}.scss`);

const NewsletterOptin = (props) => {
  const {
    number,
    title,
    text,
    termsurl,
    termstext,
    placeholder,
    buttontext,
    tagstext,
    tags,
  } = props;

  const [selectedTags, setSelectedTags] = useState([]);
  const newsletterTitle =
    title !== '' ? title : translate('signup.newsletter.header');
  const newsletterText =
    text !== '' ? text : translate('signup.newsletter.text');
  const newsletterPlaceholder =
    placeholder !== ''
      ? placeholder
      : translate('signup.newsletter.placeholder');
  const newsletterTermstext =
    termstext !== '' ? termstext : translate('signup.newsletter.termstext');
  const newsletterButtontext =
    buttontext !== '' ? buttontext : translate('signup.newsletter.buttontext');

  const [value, setValue] = useState('');
  const [resultMessage, setResultMessage] = useState('');
  const [resultSuccess, setResultSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (resultSuccess) setResultSuccess(false);
    if (resultMessage !== '') setResultMessage('');
    setIsLoading(true);

    var optInModel = {
      Email: value,
      Source: 'NewsletterWeb',
      Tags: selectedTags,
    };

    await post('/api/mailchimp/optin', optInModel)
      .then((result) => {
        setResultSuccess(true),
          setResultMessage(translate('signup.newsletter.subscribed'));
      })
      .catch(() => {
        setResultSuccess(false),
          setResultMessage(translate('signup.newsletter.error'));
      });
    setIsLoading(false);
  };

  const handleInputChange = (e) => {
    setValue(e.target.value);
    if (resultSuccess) setResultSuccess(false);
    if (resultMessage !== '') setResultMessage('');
  };

  const handleTermsChange = (e) => {
    setAcceptedTerms(!acceptedTerms);
    if (resultSuccess) setResultSuccess(false);
    if (resultMessage !== '') setResultMessage('');
  };

  const handleTagChange = (e, k) => {
    let newSelectedTags = selectedTags.slice();
    if (newSelectedTags.includes(k)) {
      setSelectedTags(newSelectedTags.filter((item) => item !== k));
    } else {
      newSelectedTags.push(k);
      setSelectedTags(newSelectedTags);
    }
  };

  const noTagsSelected = Object.values(tags).length && selectedTags.length < 1;

  return (
    <>
      <h4 className="news-letter-signup__title">{newsletterTitle}</h4>
      <div className="news-letter-signup__text">{newsletterText}</div>
      <form onSubmit={handleSubmit} className="news-letter-signup__form">
        <input
          id="newsletter-signup__input"
          type="text"
          value={value}
          onChange={(e) => handleInputChange(e)}
          placeholder={newsletterPlaceholder}
        />
        <button
          type="submit"
          disabled={isLoading || !acceptedTerms || noTagsSelected}
          className="btn btn-small news-letter-signup__btn"
        >
          {isLoading ? <LoadingSpinner /> : newsletterButtontext}
        </button>
      </form>
      {Object.values(tags).length > 0 && (
        <div className="news-letter-signup__tags">
          {tagstext && (
            <div className="news-letter-signup__tags__text">{tagstext}</div>
          )}
          <div className="news-letter-signup__tags__inner">
            {Object.keys(tags).map((key, i) => (
              <div className="news-letter-signup__tags__inner__tag" key={i}>
                <input
                  type="checkbox"
                  className="checkbox news-letter-signup__checkbox"
                  id={`newsletter-signup-tag-${i}`}
                  checked={selectedTags.includes(key)}
                  onChange={(event) => handleTagChange(event, key)}
                />
                <label
                  className="news-letter-signup__tags__inner__tag__label"
                  htmlFor={`newsletter-signup-tag-${i}`}
                >
                  {tags[key]}
                </label>
              </div>
            ))}
          </div>
        </div>
      )}
      <div className="news-letter-signup__terms--wrapper">
        <input
          type="checkbox"
          className="checkbox news-letter-signup__checkbox"
          id={`newsletter-signup-terms-${number}`}
          checked={acceptedTerms}
          onChange={(event) => handleTermsChange(event)}
        />
        <label
          className="news-letter-signup__terms--label"
          htmlFor={`newsletter-signup-terms-${number}`}
        >
          {newsletterTermstext}
        </label>
        <a
          href={termsurl}
          target="_blank"
          className="news-letter-signup__link"
          rel="noreferrer"
        >
          {translate('signup.newsletter.termsurl')}
        </a>
      </div>
      {resultMessage && (
        <span
          className={`news-letter-signup__message news-letter-signup__message--${
            resultSuccess ? 'success' : 'error'
          }`}
        >
          {resultMessage}
        </span>
      )}
    </>
  );
};

export default NewsletterOptin;
